import { Pipe, PipeTransform } from '@angular/core';
import { BaseLocaleNumberPipe } from './base-locale-number.pipe';
import { NumberFormatStyle } from './enums/number-format-style.enum';

@Pipe({
  name: 'localeCurrency',
  standalone: true,
  pure: false,
})
export class LocaleCurrencyPipe extends BaseLocaleNumberPipe implements PipeTransform {
  transform(
    value: number | null | undefined,
    currencyCode = 'EUR',
    display: 'code' | 'symbol' | 'narrowSymbol' | 'name' = 'symbol',
    minFractionDigits?: number,
    maxFractionDigits?: number
  ): string {
    if (value == null) {
      return '';
    }

    return this.formatNumber(value, {
      style: NumberFormatStyle.Currency,
      currency: currencyCode,
      currencyDisplay: display,
      minimumFractionDigits: minFractionDigits,
      maximumFractionDigits: maxFractionDigits,
      useGrouping: true,
    });
  }
}
